import { render, staticRenderFns } from "./ManagePlans.vue?vue&type=template&id=826ae00c&scoped=true&"
import script from "./ManagePlans.vue?vue&type=script&lang=js&"
export * from "./ManagePlans.vue?vue&type=script&lang=js&"
import style0 from "./ManagePlans.vue?vue&type=style&index=0&id=826ae00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826ae00c",
  null
  
)

export default component.exports